import type { Session } from "@supabase/supabase-js";

/** An isolated checkout payer is not a signed-in customer account. */
export function accountNavigationSession(session: Session | null | undefined): Session | null {
  const user = session?.user;
  if (!user || user.role === "checkout_guest" || user.app_metadata?.checkout_guest === true) return null;
  return session ?? null;
}
